import React from 'react';
import styles from './MyCaseStatus.module.scss';
import classnames from 'classnames';

interface Props {
  PageData?: any;
  Model?: any;
  LayoutModel?: any;
}

const MyCaseStatus = (props: Props) => {
  const { Model, PageData, LayoutModel } = props;
  return (
    <div
      data-type="Promotion"
      data-creative-slot="Portal-Home-Top"
      data-promotion-name="Case status"
      className={classnames(
        styles.MyCaseStatus_card,
        Model?.PerformingStatus
          ? styles.sucess_card
          : Model?.PerformingWithArrearsStatus
          ? styles.wait_card
          : '',
      )}
    >
      <h2 className={styles.MyCaseStatus_cardheading}>
        {PageData?.CaseStatusHeader}
      </h2>
      <div
        className={classnames(
          Model?.PerformingStatus
            ? styles.sucesscard_text
            : Model?.PerformingWithArrearsStatus
            ? styles.waitcard_text
            : styles.MyCaseStatus_cardtext,
        )}
      >
        <span>{Model?.SecuredStatusText}</span>
      </div>
      <a
        href={Model?.securedFaqPageUrl}
        className={styles.MyCaseStatus_cardLink}
      >
        {PageData?.LearnMoreLinkText}
      </a>
      <div className={styles.MyCaseStatus_cardlist}>
        {Model?.SecuredEndPaymentDate && (
          <div className={styles.MyCaseStatus_cardlist_item}>
            <span className={styles.MyCaseStatus_cardlist_content}>
              {PageData?.DateOfEndPaymentText}
            </span>
            <span className={styles.MyCaseStatus_cardlist_contentstatus}>
              {Model?.SecuredEndPaymentDate}
            </span>
          </div>
        )}
        {Model?.OrientationHearingDate && (
          <div className={styles.MyCaseStatus_cardlist_item}>
            <span className={styles.MyCaseStatus_cardlist_content}>
              {PageData?.OrientationHearingDateText}
            </span>
            <span className={styles.MyCaseStatus_cardlist_contentstatus}>
              {Model?.OrientationHearingDate}
            </span>
          </div>
        )}
        {Model?.SellingDeadlineDate && (
          <div className={styles.MyCaseStatus_cardlist_item}>
            <span className={styles.MyCaseStatus_cardlist_content}>
              {PageData?.SellingDeadlineText}
            </span>
            <span className={styles.MyCaseStatus_cardlist_contentstatus}>
              {Model?.SellingDeadlineDate}
            </span>
          </div>
        )}
        {Model?.AdjudicationJudgmentDate && (
          <div className={styles.MyCaseStatus_cardlist_item}>
            <span className={styles.MyCaseStatus_cardlist_content}>
              {PageData?.AdjudicationJudgmentDate}
            </span>
            <span className={styles.MyCaseStatus_cardlist_contentstatus}>
              {Model?.AdjudicationJudgmentDate}
            </span>
          </div>
        )}
        {Model?.AudienceAdjudicationDate && (
          <div className={styles.MyCaseStatus_cardlist_item}>
            <span className={styles.MyCaseStatus_cardlist_content}>
              {PageData?.AudienceAdjudicationDate}
            </span>
            <span className={styles.MyCaseStatus_cardlist_contentstatus}>
              {Model?.AudienceAdjudicationDate}
            </span>
          </div>
        )}
      </div>
      {Model?.DisplayBottomSecuredCardText && (
        <p className={styles.MyCaseStatus_card_text}>
          {Model?.BottomSecuredCardText}
        </p>
      )}
      {Model?.DisplayAdditionalBottomText && (
        <div
          className={styles.MyCaseStatus_card_additionaltext}
          dangerouslySetInnerHTML={{
            __html: Model?.AdditionalBottomText,
          }}
        />
      )}
    </div>
  );
};

export default MyCaseStatus;
